{
  "tabs": {
    "overview": "Overview",
    "transfers": "Transfers",
    "portfolio": "Portfolio",
    "ledger": "Ledger",
    "trades": "Trades"
  },
  "state": {
    "FROZEN": "Frozen",
    "ACTIVE": "Active",
    "INACTIVE": "Closed",
    "AWAITING_APPROVAL": "Awaiting Approval"
  },
  "highlights": {
    "tradingProcess": "Trading process",
    "goalType": "Goal type: {{goalType}}",
    "portfolio": "Portfolio: {{portfolioType}}",
    "portfolioTheme": "Portfolio theme: {{portfolioTheme}}",
    "feeGrid": "Fee grid",
    "billingCycle": "Biling cycle",
    "skipIPS": {
      "true": "IPS: Not required",
      "false": "IPS: Required"
    },
    "allowDeposit": "Allow deposits",
    "suitabilityScore": "Suitability score: {{score}}",
    "allowFractionalShares": "Allow fractional shares",
    "liquidated": "Sub-account liquidated"
  },
  "createdAt": "Created at {{date}}",
  "subAccountInformation": "Sub-account Information",
  "linkedGoal": "Linked Goal",
  "account": "Account",
  "portfolioInformation": "Portfolio Information",
  "portfolioTheme": "Portfolio Theme",
  "portfolio": "Portfolio",
  "Fees": "Fees",
  "feeGrid": "Fee Grid",
  "BilingCycle": "Biling Cycle",
  "frequency": {
    "BI_WEEKLY": "Bi-Weekly",
    "DAILY": "Daily",
    "LAST_DAY_OF_THE_MONTH": "Last day of the month",
    "MONTHLY": "Monthly",
    "ONE_TIME": "One time",
    "SEMI_MONTHLY": "Semi-Monthly",
    "WEEKLY": "Weekly",
    "ANNUAL": "Annually",
    "QUARTERLY": "Quarterly",
    "SEMESTRAL": "Semestral"
  },
  "acceptablePortfolio": "Acceptable portfolio",
  "notAcceptablePortfolio": "Not acceptable portfolio",
  "notAcceptableFinancialProduct": "This is not an acceptble financial product",
  "editSubAccount": "Edit Sub-account"
}
